export function isDriverAppWebView() {
    return !!navigator?.userAgent?.includes("driver-app");
}
